export enum ACTIVITY_TYPE {
  INCENT_OUTCOMES_EARN = 'Incent.Outcomes.Earn',
  BEHAVIOR_CAMPAIGN_EARN = 'Behavior.Campaign.Earn',
  STAFF_POINT_EARN = 'Staff.Point.Earn',
  CAMPAIGN_POINT_EARN = 'Campaign.Point.Earn',
  SURVEY_POINT_EARN = 'Survey.Point.Earn',
  SHOPMARATHON_EARN_GAME = 'ShopMarathon.Earn.Game',
  PARTNER_REDEEM = 'Partner.Redeem',
  REWARD_STORE_REDEEM = 'Reward.Store.Redeem',
  INCENT_OUTCOMES_REDEEM = 'Incent.Outcomes.Redeem',
  POS_VOID = 'POS.Void',
  POS_REFUND = 'POS.Refund',
  POS_SPEND = 'POS.Spend',
  COIN_BEHAVIOR_CAMPAIGN_REFUND = 'Coin.Behavior.Campaign.Refund',
  COIN_MANUAL_POINTADJUST_ADD = 'Coin.Manual.PointAdjust.Add',
  COIN_MANUAL_POINTADJUST_DEDUCT = 'Coin.Manual.PointAdjust.Deduct',
  COIN_REFUND = 'Coin.Refund',
  BEHAVIOR_CAMPAIGN_REFUND = 'Behavior.Campaign.Refund',
  MANUAL_POINTADJUST_ADD = 'Manual.PointAdjust.Add',
  POINT_REFUND = 'Point.Refund',
  MANUAL_POINTADJUST_DEDUCT = 'Manual.PointAdjust.Deduct',
  LOYALTYGAME_EARN_GAME = 'LoyaltyGame.Earn.Game'
}

export const ACTIVITY_REDEEM_TYPE = [
  ACTIVITY_TYPE.PARTNER_REDEEM,
  ACTIVITY_TYPE.REWARD_STORE_REDEEM,
  ACTIVITY_TYPE.INCENT_OUTCOMES_REDEEM,
]

export const ACTIVITY_POS_TYPE = [
  ACTIVITY_TYPE.POS_VOID,
  ACTIVITY_TYPE.POS_REFUND,
  ACTIVITY_TYPE.POS_SPEND
]
